<template>
  <section class="supplier-advanced-tab">
    <header class="supplier-advanced-tab__header">
      <h4>{{ text.detail.settingsTab.title }}</h4>
      <p>{{ text.detail.settingsTab.description }}</p>
    </header>

    <div class="supplier-advanced-tab__cards">
      <article class="supplier-advanced-tab__card supplier-advanced-tab__card--merge">
        <h5>{{ text.detail.settingsTab.cards.merge.title }}</h5>
        <p>{{ text.detail.settingsTab.cards.merge.description }}</p>
        <p class="supplier-advanced-tab__warning">{{ text.detail.settingsTab.cards.merge.warning }}</p>
        <button
          type="button"
          class="app-header-btn app-header-btn--secondary"
          @click="$emit('open-merge')"
        >
          {{ text.detail.settingsTab.cards.merge.action }}
        </button>
      </article>

      <article class="supplier-advanced-tab__card supplier-advanced-tab__card--archive">
        <h5>{{ archiveCardTitle }}</h5>
        <p>{{ archiveCardDescription }}</p>
        <button
          type="button"
          class="app-header-btn app-header-btn--secondary"
          @click="$emit('archive-toggle')"
        >
          {{ archiveCardAction }}
        </button>
      </article>

      <article class="supplier-advanced-tab__card supplier-advanced-tab__card--danger">
        <h5>{{ text.detail.settingsTab.cards.delete.title }}</h5>
        <p>{{ text.detail.settingsTab.cards.delete.description }}</p>
        <button
          type="button"
          class="app-header-btn app-header-btn--delete"
          @click="$emit('delete-supplier')"
        >
          {{ text.detail.settingsTab.cards.delete.action }}
        </button>
      </article>
    </div>
  </section>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('suppliers');

export default {
  name: 'SupplierDetailAdvancedOptionsTab',
  emits: ['open-merge', 'archive-toggle', 'delete-supplier'],
  props: {
    supplier: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      text,
    };
  },
  computed: {
    supplierIsActive() {
      return Number(this.supplier?.active || 0) === 1;
    },
    archiveCardTitle() {
      return this.supplierIsActive
        ? this.text.detail.settingsTab.cards.archive.title
        : this.text.detail.settingsTab.cards.unarchive.title;
    },
    archiveCardDescription() {
      return this.supplierIsActive
        ? this.text.detail.settingsTab.cards.archive.description
        : this.text.detail.settingsTab.cards.unarchive.description;
    },
    archiveCardAction() {
      return this.supplierIsActive
        ? this.text.detail.settingsTab.cards.archive.action
        : this.text.detail.settingsTab.cards.unarchive.action;
    },
  },
};
</script>

<style scoped>
.supplier-advanced-tab {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.supplier-advanced-tab__header h4 {
  margin: 0;
  font-size: 26px;
  line-height: 32px;
  color: #1f2937;
}

.supplier-advanced-tab__header p {
  margin: 6px 0 0;
  color: #6b7280;
  font-size: 14px;
}

.supplier-advanced-tab__cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.supplier-advanced-tab__card {
  border: 1px solid rgba(148, 163, 184, 0.28);
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 10px 24px -22px rgba(15, 23, 42, 0.45);
  min-height: 198px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.supplier-advanced-tab__card::before {
  content: '';
  width: 54px;
  height: 4px;
  border-radius: 999px;
  margin-bottom: 10px;
  background: rgba(148, 163, 184, 0.35);
}

.supplier-advanced-tab__card--merge::before {
  background: linear-gradient(90deg, #4dbfb4 0%, #00a17d 100%);
}

.supplier-advanced-tab__card--archive::before {
  background: linear-gradient(90deg, #f59e0b 0%, #d97706 100%);
}

.supplier-advanced-tab__card h5 {
  margin: 0;
  font-size: 17px;
  line-height: 24px;
  color: #111827;
}

.supplier-advanced-tab__card p {
  margin: 10px 0 0;
  font-size: 13px;
  line-height: 20px;
  color: #4b5563;
}

.supplier-advanced-tab__card:not(.supplier-advanced-tab__card--danger):hover {
  border-color: rgba(0, 112, 205, 0.32);
  box-shadow: 0 18px 35px -28px rgba(0, 112, 205, 0.55);
  transform: translateY(-1px);
}

.supplier-advanced-tab__warning {
  color: #b45309;
  font-weight: 600;
}

.supplier-advanced-tab__card .app-header-btn {
  margin-top: auto;
  align-self: center;
  min-width: 164px;
  justify-content: center;
  text-align: center;
}

.supplier-advanced-tab__card--danger {
  border-color: rgba(225, 29, 72, 0.28);
  background: linear-gradient(180deg, #ffffff 0%, #fff5f7 100%);
}

@media (max-width: 1100px) {
  .supplier-advanced-tab__cards {
    grid-template-columns: 1fr;
  }
}
</style>
